import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";

export default function CartDrawer() {
  const {
    cart,
    cartTotal,
    drawerOpen,
    closeDrawer,
    removeFromCart,
    updateQuantity,
  } = useCart();

  const navigate = useNavigate();

  const handleCheckout = () => {
    closeDrawer();
    navigate("/checkout");
  };

  return (
    <>
      {/* Overlay */}
      {drawerOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-40"
          onClick={closeDrawer}
        />
      )}

      {/* Drawer */}
      <div
        className={`fixed top-0 right-0 h-full w-full sm:w-[380px] bg-white shadow-2xl z-50 transform transition-transform duration-300 ${
          drawerOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b">
          <h2 className="text-lg font-semibold">Your Cart</h2>
          <button
            onClick={closeDrawer}
            className="text-gray-500 hover:text-black text-xl"
          >
            ×
          </button>
        </div>

        {/* Cart Content */}
        {cart.length === 0 ? (
          <div className="p-6 text-center text-gray-500">
            Your cart is empty.
            <div className="mt-4">
              <Link
                to="/products"
                onClick={closeDrawer}
                className="text-blue-600 hover:underline text-sm"
              >
                Browse products →
              </Link>
            </div>
          </div>
        ) : (
          <div className="flex flex-col h-full">
            <div className="flex-1 overflow-y-auto p-4 space-y-4 pb-28">
              {cart.map((item) => (
                <div
                  key={item.key}
                  className="flex gap-3 border-b pb-3 last:border-b-0"
                >
                  <div className="w-16 h-16 bg-gray-100 rounded overflow-hidden flex-shrink-0">
                    {item.images?.[0] ? (
                      <img
                        src={item.images[0]}
                        alt={item.name}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-xs text-gray-400">
                        No image
                      </div>
                    )}
                  </div>

                  <div className="flex-1">
                    <div className="text-sm font-semibold line-clamp-2">
                      {item.name}
                    </div>

                    {/* Variant */}
                    {item.variantName && (
                      <div className="text-xs text-gray-500">
                        Variant: {item.variantName}
                      </div>
                    )}

                    <div className="text-xs text-gray-500 mt-1">
                      ${item.price.toLocaleString()}
                    </div>

                    <div className="flex items-center mt-2 gap-2">
                      <button
                        onClick={() =>
                          updateQuantity(item.key, item.qty - 1)
                        }
                        className="w-6 h-6 flex items-center justify-center border rounded text-sm"
                      >
                        −
                      </button>

                      <div className="text-sm w-6 text-center">
                        {item.qty}
                      </div>

                      <button
                        onClick={() =>
                          updateQuantity(item.key, item.qty + 1)
                        }
                        className="w-6 h-6 flex items-center justify-center border rounded text-sm"
                      >
                        +
                      </button>

                      <button
                        onClick={() => removeFromCart(item.key)}
                        className="ml-auto text-xs text-red-500 hover:underline"
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Footer */}
            <div className="border-t p-4 bg-white sticky bottom-0 left-0">
    <div className="flex justify-between mb-3 text-sm">
      <span className="text-gray-600">Subtotal</span>
      <span className="font-semibold">${cartTotal.toLocaleString()}</span>
    </div>

    <p className="text-xs text-gray-500 mb-3">
      Taxes & shipping calculated at checkout.
    </p>

    <button
      onClick={handleCheckout}
      className="w-full bg-black text-white py-3 rounded-lg text-sm font-medium hover:bg-gray-800"
    >
      Proceed to Checkout
    </button>
  </div>
</div>
        )}
      </div>
    </>
  );
}
